
/* Check for specific network IDs and empIDs to verify if the landing page
and type drop-down should show only medical types or not
in order to support Monument Health Open enrollment per story PD-2778
Networks to check: 1099, 1050, 1090
empID: 40994
Group: Monument Health
*/
export default (profile, context) => {
  
    const isMonumentHealth = computed(() => {
      if (!profile.isAuthenticated) {
        if ((context.networkId == '1099' || context.networkId == '1050' || context.networkId == '1090') && context.empId == '40994') {
          return true
        }
      }
  
      return false
    })
  
    return { isMonumentHealth }
  }